import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import FormSelect from '../../../../_shared/forms/FormSelect';

export default class ReassignToSubContractorModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: null,
            selected_service_provider: '',
        };
    }

    handleServiceProviderChange = (e) => {
        const { value } = e.target;
        this.setState({
            selected_service_provider: value,
        });
    };

    handleDateChange = (date) => {
        if (moment(date).isValid()) {
            this.setState({ date: date });
        } else {
            this.setState({ date: null });
        }
    };

    reassignToServiceProvider(e) {
        e.stopPropagation();

        let formData = new FormData();
        formData.append('_method', 'PATCH');
        formData.append('execution_date', moment(this.state.date).format('YYYY/MM/DD'));
        formData.append('provider', this.state.selected_service_provider);

        const requests = this.props.selectedJobs.map((job) => {
            return axios
                .post(`/jobs/${job}/reallocate`, formData)
                .then((res) => {
                    toastr.success('Reassigned job(s)');
                })
                .catch((err) => {
                    toastr.error('There was a problem, please try again');
                });
        });

        Promise.all(requests)
            .then(() => {
                window.location.reload();
            })
            .catch((err) => {
                console.error('There was a problem reassigning jobs', err);
            });
    }

    render() {
        return (
            <div
                className="admin-notes-modal"
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className="admin-notes-modal-body">
                    <div className="admin-modal-content">
                        <h4>{`Re-assign ${this.props.selectedJobs.length} job(s)`}</h4>
                        <hr />
                        <div className="form-group">
                            <label htmlFor="date">Date</label>
                            <DatePicker
                                selected={this.state.date}
                                onChange={(date) => this.handleDateChange(date)}
                                onClick={(e) => this.stopPropagation(e)}
                                minDate={new Date()}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                placeholderText="Select Planned Date"
                            />
                        </div>
                        <div className="form-group">
                            <FormSelect
                                label="Sub Contractors"
                                name="service_providers"
                                classes={'form-control'}
                                value={this.state.selected_service_provider}
                                options={this.props.serviceProviders.map((provider) => ({
                                    id: provider.id,
                                    name: provider.name,
                                }))}
                                handleChange={this.handleServiceProviderChange}
                            />
                        </div>
                        <div className="form-group">
                            <button
                                className="btn btn-cw-primary ml-2"
                                onClick={(e) => this.reassignToServiceProvider(e)}
                                disabled={this.state.date === null || this.state.selected_service_provider === ''}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                    <hr />
                    <div className="admin-notes-modal-footer">
                        <button className="btn btn-cw-primary" onClick={(e) => this.props.onHide(e, false)}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
